import { render, staticRenderFns } from "./AnnouncePopup.vue?vue&type=template&id=3e355b6d&scoped=true"
import script from "./AnnouncePopup.vue?vue&type=script&lang=js"
export * from "./AnnouncePopup.vue?vue&type=script&lang=js"
import style0 from "./AnnouncePopup.vue?vue&type=style&index=0&id=3e355b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e355b6d",
  null
  
)

export default component.exports